import { useSearchParams } from 'react-router-dom';
import { useBranding } from '../../api/auth';

/** Branding for the current hostname (or ?tenant=slug on shared hosts). */
export function useBrandingForPage() {
  const [params] = useSearchParams();
  const slug = params.get('tenant')?.trim().toLowerCase() || null;
  const q = useBranding(window.location.host, slug);
  return { ...q, slugParam: slug };
}
